var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('el-dialog', {
    attrs: {
      "title": _vm.dataForm.id ? 'Edit Supplier' : 'Add Supplier',
      "close-on-click-modal": false,
      "visible": _vm.visible,
      "width": "900px",
      "top": "2vh"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.visible = $event;
      }
    }
  }, [_c('el-form', {
    ref: "dataForm",
    attrs: {
      "model": _vm.dataForm,
      "rules": _vm.dataRule,
      "autocomplete": "off",
      "label-position": "top"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('copy-from', {
    attrs: {
      "dataForm": _vm.dataForm,
      "options": _vm.supplierList,
      "labelFormatter": function labelFormatter(item) {
        return "".concat(item.abbr, "-").concat(item.companyName);
      }
    },
    on: {
      "copyFromTrigger": _vm.copyFromTrigger
    }
  })], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Abbreviation",
      "prop": "abbr"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "e.g. EStar"
    },
    model: {
      value: _vm.dataForm.abbr,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "abbr", $$v);
      },
      expression: "dataForm.abbr"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Invoice Prefix",
      "prop": "invoiceNumberPrefix"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "e.g. ESTAR-"
    },
    model: {
      value: _vm.dataForm.invoiceNumberPrefix,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "invoiceNumberPrefix", $$v);
      },
      expression: "dataForm.invoiceNumberPrefix"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Company Name",
      "prop": "companyName"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "Full legal name"
    },
    model: {
      value: _vm.dataForm.companyName,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "companyName", $$v);
      },
      expression: "dataForm.companyName"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Registration No.",
      "prop": "registrationNo"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "e.g. 201917568E"
    },
    model: {
      value: _vm.dataForm.registrationNo,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "registrationNo", $$v);
      },
      expression: "dataForm.registrationNo"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Country",
      "prop": "country"
    }
  }, [_c('el-select', {
    staticClass: "wdb100",
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "Country"
    },
    model: {
      value: _vm.dataForm.country,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "country", $$v);
      },
      expression: "dataForm.country"
    }
  }, _vm._l(_vm.countryList, function (item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.title,
        "value": item.value
      }
    });
  }), 1)], 1)], 1), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Billing Address",
      "prop": "billingAddress"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "Street address"
    },
    model: {
      value: _vm.dataForm.billingAddress,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "billingAddress", $$v);
      },
      expression: "dataForm.billingAddress"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Post Code",
      "prop": "postCode"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: _vm.dataForm.postCode,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "postCode", $$v);
      },
      expression: "dataForm.postCode"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Email",
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: _vm.dataForm.email,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "email", $$v);
      },
      expression: "dataForm.email"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Default Invoice Template"
    }
  }, [_c('div', {
    staticClass: "pt20 invoiceTemplateWrap"
  }, _vm._l(_vm.dataForm.defaultInvoiceTemplates, function (item, idx) {
    return _c('div', {
      key: item.businessGenre,
      staticClass: "wdb100 customElFormItem"
    }, [_c('el-form-item', {
      attrs: {
        "label": item.businessLabel,
        "prop": "defaultInvoiceTemplates.".concat(idx, ".invoiceTemplateId")
      }
    }, [_c('el-select', {
      staticClass: "wdb100",
      attrs: {
        "clearable": "",
        "filterable": "",
        "placeholder": "Select Template"
      },
      model: {
        value: item.invoiceTemplateId,
        callback: function callback($$v) {
          _vm.$set(item, "invoiceTemplateId", $$v);
        },
        expression: "item.invoiceTemplateId"
      }
    }, _vm._l(_vm.invoiceTemplateList, function (item) {
      return _c('el-option', {
        key: item.id,
        attrs: {
          "label": item.templateName,
          "value": item.id
        }
      });
    }), 1)], 1)], 1);
  }), 0)])], 1), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Company Logo",
      "prop": "companyLogoUrl"
    }
  }, [_c('div', {
    staticClass: "imageArea"
  }, [_c('el-image-uploader', {
    model: {
      value: _vm.dataForm.companyLogoUrl,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "companyLogoUrl", $$v);
      },
      expression: "dataForm.companyLogoUrl"
    }
  })], 1)])], 1), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tax Types",
      "prop": "taxInfos",
      "rules": {
        type: 'array',
        required: !_vm.dataForm.hasNoTax,
        message: 'please add',
        trigger: 'submit'
      }
    }
  }, [_c('div', {
    staticClass: "taxTypeWrap"
  }, [_c('div', {
    staticClass: "checkboxWrap"
  }, [_c('el-checkbox', {
    attrs: {
      "true-label": 1,
      "false-label": 0
    },
    on: {
      "change": _vm.hasNoTaxChange
    },
    model: {
      value: _vm.dataForm.hasNoTax,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "hasNoTax", $$v);
      },
      expression: "dataForm.hasNoTax"
    }
  }, [_vm._v("No Tax (N/A)")])], 1), _c('div', {
    staticClass: "wdb100 fs0 lh0"
  }, [_vm._l(_vm.dataForm.taxInfos, function (item, index) {
    return _c('div', {
      key: "taxType-".concat(index),
      staticClass: "wdb100"
    }, [_c('el-row', {
      attrs: {
        "gutter": 10
      }
    }, [_c('el-col', {
      attrs: {
        "span": 16
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": "taxInfos.".concat(index, ".taxType"),
        "rules": {
          required: true,
          message: 'please enter',
          trigger: 'submit'
        }
      }
    }, [_c('el-input', {
      attrs: {
        "clearable": "",
        "placeholder": "Tax type",
        "disabled": !!_vm.dataForm.hasNoTax
      },
      model: {
        value: item.taxType,
        callback: function callback($$v) {
          _vm.$set(item, "taxType", $$v);
        },
        expression: "item.taxType"
      }
    })], 1)], 1), _c('el-col', {
      attrs: {
        "span": 6
      }
    }, [_c('el-form-item', {
      staticClass: "flexItem",
      attrs: {
        "prop": "taxInfos.".concat(index, ".taxRate"),
        "rules": {
          required: true,
          message: 'please enter',
          trigger: 'submit'
        }
      }
    }, [_c('el-input-number', {
      staticClass: "tal wdb100",
      attrs: {
        "precision": 2,
        "min": 0,
        "controls-position": "right",
        "placeholder": "Rate %",
        "disabled": !!_vm.dataForm.hasNoTax
      },
      model: {
        value: item.taxRate,
        callback: function callback($$v) {
          _vm.$set(item, "taxRate", $$v);
        },
        expression: "item.taxRate"
      }
    }), _c('span', {
      staticClass: "ml4"
    }, [_vm._v("%")])], 1)], 1), _c('el-col', {
      staticClass: "tac",
      attrs: {
        "span": 2
      }
    }, [_c('el-button', {
      attrs: {
        "type": "danger",
        "size": "small",
        "icon": "el-icon-delete",
        "plain": ""
      },
      on: {
        "click": function click($event) {
          return _vm.deleteHandle(index);
        }
      }
    })], 1)], 1)], 1);
  }), _c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-plus",
      "size": "mini",
      "plain": "",
      "disabled": !!_vm.dataForm.hasNoTax
    },
    on: {
      "click": _vm.addHandle
    }
  }, [_vm._v("Add Tax Type")])], 2)])])], 1)], 1)], 1), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function click($event) {
        _vm.visible = false;
      }
    }
  }, [_vm._v("Cancel")]), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submitLoading
    },
    on: {
      "click": _vm.dataFormSubmit
    }
  }, [_vm._v("OK")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }